import React from "react";
import ActionButton from "../ActionButton";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper();

/**
 * Custom hook for creating an actions column for a table.
 *
 * @param {{ label: React.ReactNode | (row) => React.ReactNode; onClick: (row) => void; hidden?: (row) => boolean; disabled?: (row) => boolean; }[]} actionsConfig
 * Configuration for action buttons. Each action should have a label and an onClick handler.
 * The label can be a string or a function that takes the row data and returns a React node. A function is useful for dynamic labels based on row data.
 * @param {string} columnWidth Width of the actions column.
 */
function useActionsColumn(actionsConfig, columnWidth = "10%") {
    return columnHelper.display({
        id: "actions",
        header: "",
        width: columnWidth,
        cell: ({ row }) => {
            const visibleActions = actionsConfig
                .filter((action) => !action.hidden?.(row.original))
                .map((action) => ({
                    label: typeof action.label === "function" ? action.label(row.original) : action.label,
                    onClick: () => action.onClick(row.original),
                    disabled: action.disabled?.(row.original) ?? false,
                }));

            if (visibleActions.length === 0) {
                return null;
            }

            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <ActionButton actions={visibleActions} />
                </div>
            );
        },
    });
}

export default useActionsColumn;
